// extracted by mini-css-extract-plugin
export var chatHtmlText = "_ql-2";
export var chatLink = "_ql-0";
export var chatText = "_ql-1";